// Vendor
import {ApolloLink} from 'apollo-link';

export const createAbsintheHttpBatchingParserMiddleware = () =>
  new ApolloLink((operation, forward) => {
    return forward!(operation).map((response: any) => {
      response.data = response.payload.data;
      return response;
    });
  });



// WEBPACK FOOTER //
// ./src/services/apollo/middlewares/absinthe-http-batching-parser.ts